import { __extends } from 'tslib';
import { PureComponent } from 'react';
import isEqual from 'react-fast-compare';

var DeepPureComponent = (function (_super) {
    __extends(DeepPureComponent, _super);
    function DeepPureComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeepPureComponent.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
    };
    return DeepPureComponent;
}(PureComponent));

export { DeepPureComponent };
//# sourceMappingURL=Component.js.map
